// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"42df50a3","238":"0ebeef83","394":"9fdbaace","453":"9fd167aa","578":"3bb21a8c","667":"f489b7c7","857":"2cd78cf8","977":"003f2b9f"}[chunkId] + ".chunk.js";
};